<!-- 
  Corrigir tamanho texto/imagem
  Incorporar antigas páginas de Tecnologia, Escola e Família
  -->
<template>
  <section>
    <Banner value="Proposta Pedagógica"/>
    <hr style="border:5px solid #DDD">

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-4>
          <v-flex xs12>
            <p
              class="lead"
            >É muito importante para toda a equipe da Escola Engenho ter a certeza de que existe rigor científico e amor no trabalho que fazemos. Por isso, promovemos uma busca constante por sabedorias que fundamentam e melhoram progressivamente nossa prática diária.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <!-- <v-flex md3>
            <img src="/images/lev-vygotsky.jpg" alt="Vygotsky" style="width:100%;">
            <p>
              <small>Lev Vygotsky</small>
            </p>
          </v-flex> -->
          <v-flex md12>
            <h1 style="text-align:left; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Embasamento</span>
              <br>Teórico da Escola Engenho
            </h1>
            <br>
            <p
              class="lead"
            >A Escola Engenho inspira-se no modelo teórico metodológico da teoria Histórico-cultural de Vigotsky. Nele é onde encontramos fundamentações e caminhos para garantir uma vivência solidária e democrática no ambiente social em que todos estão inseridos.</p>
            <p
              class="lead"
            >Somado a isso, também contamos com as influências filosóficas e pedagógicas contemporâneas da qual também participa a Psicopedagogia, mostrando a necessidade do processo ensino-aprendizagem na formação dos alunos.</p>
            <p
              class="lead"
            >A diversidade e a singularidade de cada estudante em nossa escola é bem vinda e trabalhada para mediar as tensões que emergem em toda e qualquer situação relacional.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:#EEE;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <!-- <v-flex md3>
            <img src="/images/familia.gif" alt="Família" style="width:100%;">
          </v-flex> -->
          <v-flex md12>
            <h1 style="text-align:left; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Material</span>
              <br>didático
            </h1>
            <br>
            <p class="lead">A Escola Engenho não adota sistema de ensino apostilado. O material didático adotado está de acordo com a proposta pedagógica da escola, valorizando a diversidade, a autonomia e a autoria dos professores em sala de aula.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:none;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <!-- <v-flex md3>
            <img src="/images/familia.gif" alt="Família" style="width:100%;">
          </v-flex> -->
          <v-flex md12>
            <h1 style="text-align:left; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Famílias</span>
              <br>e a Escola Engenho
            </h1>
            <br>
            <p class="lead">A participação dos pais e/ou responsáveis é indispensável para o sucesso do processo de ensino-aprendizagem. Através das tarefas, trabalhos e atividades podem acompanhar a rotina escolar, os conteúdos e as habilidades desenvolvidas.</p>

            <p class="lead">Nas reuniões de pais (coletivas ou individuais) têm um espaço de troca e avaliação e, sempre que necessário, são chamados a participar mais efetivamente, com a orientação da escola.</p>
            
            <p class="lead">Além disso, a Escola promove eventos - como a gincana, mostra de trabalhos e comemorações - para que todos possam participar, sobretudo os pais.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section style="background:#EEE">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap my-4>
          <!-- <v-flex md3>
            <img src="/images/tecnologia.gif" alt="Vygotsky" style="width:100%;">
          </v-flex> -->
          <v-flex md12>
            <h1 style="text-align:left; font-size:25px; line-height:1.1em;">
              <span style="font-size:45px;">Tecnologias</span>
              <br>e a aprendizagem
            </h1>
            <br>
            <p
              class="lead"
            >Numa sociedade onde existe uma presença marcante e inédita das TICs (Tecnologias de Informação e Comunicação) é fundamental saber usar com sabedoria recursos tecnológicos para garantir que, além de estarem presentes, colaborem verdadeiramente para o desenvolvimento mental e emocional dos estudantes.</p>
            <p
              class="lead"
            >Nossas instalações incluem a presença de equipamentos conectados à internet em todas as salas. Eles facilitam o estudo e permitem a realização mais rápida de pesquisas. Além disso, oferecerem aos professores recursos para melhorarem ainda mais as aulas de acordo com a sua necessidade.</p>
            <p
              class="lead"
            >Nossa experiência tem mostrado que, num ambiente saudável, onde há boa relação entre direção, professores, pais e estudantes, a tecnologia é capaz de entregar o que promete: maior engajamento e aprendizado por parte de todos.</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({}),
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: justify !important;
}
ul li,
ol li {
  margin-top: 10px;
}
</style>


